import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 
		messageCount:0,
    settlement:{
      Fpage:1,
      tag:0,
      orderTab:'0',
      page:1,
      supplierTag:'1',
    },
    user_name: localStorage.getItem('user_name'),
  },
  mutations: {
		setMessageCount(state,messageCount){
			state.messageCount = messageCount
		},
    handleUserName: (state, user_name) => {
      state.user_name = user_name;
      localStorage.setItem('user_name', user_name)
    }
  },
  actions: {
  },
  modules: {
  }
})
